import * as FrontCubeData from '../frontCubeData/index';

export function updateDepByCubeId(cubeId: CubeId): void {
    let cubeDep: any = FrontCubeData.depGet(cubeId);

    for (let key in cubeDep) {
        if (cubeDep[key].currentValue === cubeDep[key].lastValue) {
            continue;
        }

        cubeDep[key].lastValue = cubeDep[key].currentValue;
        cubeDep[key].dep.notify();
    }
}
